<script setup lang="ts">
interface Props {
  title?: string;
  subtitle?: string;
}

withDefaults(defineProps<Props>(), {
  title: "Нет данных для отображения",
  subtitle: "Данные по указанным регионам за выбранный\nпериод еще не загружены в систему"
});
</script>

<template>
  <div class="table-message">
    <h3 class="table-message__title">
      {{ title }}
    </h3>
    <span class="table-message__subtitle">
      {{ subtitle }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.table-message {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9;
  position: absolute;
  gap: 20px;
  background-color: var(--background-bg-white);

  &__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }

  &__subtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    white-space: pre-line;
  }
}
</style>